// extracted by mini-css-extract-plugin
export default {"mySlct":"MyInputSelect_mySlct__NNGE3"};